/* TLC × A–Z Ingredients & Notes Library */
(function () {
  function init(root) {
    if (!root || root.dataset.azlReady) return;
    root.dataset.azlReady = '1';

    var panes = {
      ingredients: root.querySelector('[data-azl-pane="ingredients"]'),
      notes: root.querySelector('[data-azl-pane="notes"]')
    };
    var toggleBtns = root.querySelectorAll('[data-azl-tab]');
    var current = 'ingredients';

    function paneCtx() {
      var pane = panes[current];
      return {
        pane: pane,
        cards: pane ? pane.querySelectorAll('.azl-card') : [],
        groups: pane ? pane.querySelectorAll('.azl-group') : [],
        search: pane ? pane.querySelector('[data-azl-search]') : null,
        count: pane ? pane.querySelector('[data-azl-count]') : null,
        chips: pane ? pane.querySelectorAll('[data-azl-cat]') : [],
        az: pane ? pane.querySelectorAll('[data-azl-letter]') : [],
        empty: pane ? pane.querySelector('[data-azl-empty]') : null,
        noun: pane ? (pane.dataset.noun || 'entries') : 'entries'
      };
    }

    function activeCat(ctx) {
      var on = ctx.pane.querySelector('[data-azl-cat].is-on');
      return on ? on.getAttribute('data-azl-cat') : '';
    }

    function apply() {
      var ctx = paneCtx();
      if (!ctx.pane) return;
      var q = (ctx.search && ctx.search.value || '').trim().toLowerCase();
      var cat = activeCat(ctx);
      var shown = 0;
      var lettersWith = {};

      ctx.cards.forEach(function (card) {
        var name = card.getAttribute('data-name') || '';
        var fam = card.getAttribute('data-family') || '';
        var matchQ = !q || name.indexOf(q) > -1 || fam.indexOf(q) > -1;
        var matchCat = !cat || fam.split(' ').indexOf(cat) > -1;
        var ok = matchQ && matchCat;
        card.classList.toggle('is-hidden', !ok);
        if (ok) { shown++; lettersWith[card.getAttribute('data-letter')] = true; }
      });

      ctx.groups.forEach(function (g) {
        var any = g.querySelector('.azl-card:not(.is-hidden)');
        g.classList.toggle('is-empty', !any);
      });
      ctx.az.forEach(function (b) {
        var l = b.getAttribute('data-azl-letter');
        b.disabled = !lettersWith[l];
        b.classList.remove('is-on');
      });
      if (ctx.count) ctx.count.textContent = shown + ' ' + ctx.noun;
      if (ctx.empty) ctx.empty.classList.toggle('is-on', shown === 0);
    }

    // tab switch
    function setTab(tab, push) {
      current = tab;
      Object.keys(panes).forEach(function (k) {
        if (panes[k]) panes[k].classList.toggle('is-on', k === tab);
      });
      toggleBtns.forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-azl-tab') === tab);
      });
      apply();
      if (push && history.replaceState) history.replaceState(null, '', '#' + tab);
    }
    toggleBtns.forEach(function (b) {
      b.addEventListener('click', function () { setTab(b.getAttribute('data-azl-tab'), true); });
    });

    // search (delegated per pane)
    root.querySelectorAll('[data-azl-search]').forEach(function (inp) {
      inp.addEventListener('input', apply);
    });
    // chips
    root.querySelectorAll('[data-azl-cat]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var pane = chip.closest('[data-azl-pane]');
        pane.querySelectorAll('[data-azl-cat]').forEach(function (c) { c.classList.remove('is-on'); });
        chip.classList.add('is-on');
        apply();
      });
    });
    // A-Z jump
    root.querySelectorAll('[data-azl-letter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var pane = btn.closest('[data-azl-pane]');
        var target = pane.querySelector('.azl-group[data-letter="' + btn.getAttribute('data-azl-letter') + '"]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Deep-link to a single card: #az-<slug>. The card may live in the
    // inactive pane (all 42 notes do) or be filtered out, so switch pane and
    // clear filters before scrolling, otherwise the anchor resolves to a
    // display:none element and the page appears not to move.
    function focusCard(id) {
      if (!id) return false;
      var card = document.getElementById(id);
      if (!card || !card.classList.contains('azl-card') || !root.contains(card)) return false;
      var pane = card.closest('[data-azl-pane]');
      var tab = pane && pane.getAttribute('data-azl-pane');
      if (tab && tab !== current) setTab(tab, false);
      if (pane) {
        var s = pane.querySelector('[data-azl-search]');
        if (s) s.value = '';
        pane.querySelectorAll('[data-azl-cat]').forEach(function (c) {
          c.classList.toggle('is-on', c.getAttribute('data-azl-cat') === '');
        });
        apply();
      }
      root.querySelectorAll('.azl-card.is-target').forEach(function (c) { c.classList.remove('is-target'); });
      card.classList.add('is-target');
      // The pane's .azl-tools bar is sticky and its height varies a lot with
      // chip wrapping (424px on a 375px viewport, far less on desktop), so a
      // fixed CSS scroll-margin can't clear it. Measure it at jump time.
      setTimeout(function () {
        var tools = pane ? pane.querySelector('.azl-tools') : null;
        var offset = (tools ? tools.getBoundingClientRect().height : 0) + 16;
        var y = card.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
      }, 60);
      return true;
    }

    var hash = (location.hash || '').replace('#', '');
    if (hash === 'notes' || hash === 'ingredients') {
      setTab(hash, false);
    } else {
      setTab('ingredients', false);
      focusCard(hash);
    }
    window.addEventListener('hashchange', function () {
      var h = (location.hash || '').replace('#', '');
      if (h === 'notes' || h === 'ingredients') setTab(h, true);
      else focusCard(h);
    });
  }

  function boot() {
    document.querySelectorAll('[data-azl-root]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
